exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.axis path,\n.axis line {\n    fill: none;\n    stroke: #000;\n    shape-rendering: crispEdges;\n}\n\n/*.x.axis path {\n    display: none;\n}*/\n.line {\n    fill: none;\n    stroke: lightgrey;\n    stroke-width: 3px;\n}\n\n", ""]);

// exports
